import React from 'react';
import { Select } from 'antd';
import type { CouponOption } from './use-coupon-list';
import style from './coupon-select.module.scss';

export interface CouponSelectProps {
    /** The coupons to choose from (already active-filtered by `useCouponList`). */
    coupons: CouponOption[];
    /** The currently selected coupon id (the card's `selectedCouponId`). */
    value: string | undefined;
    /** Emits the picked coupon id; the bridge threads it back into the fetch. */
    onChange: (id: string) => void;
    /** The coupon list failed to load. */
    error?: boolean;
    loading?: boolean;
}

/** Compact coupon picker for the Coupon detail section header; the page owns the selection. */
export const CouponSelect: React.FC<CouponSelectProps> = ({
    coupons,
    value,
    onChange,
    error = false,
    loading = false,
}) => (
    <Select<string>
        size="small"
        className={style.coupon_select}
        value={value}
        onChange={onChange}
        status={error ? 'error' : undefined}
        loading={loading}
        options={coupons.map((coupon) => ({
            value: coupon.id,
            label: coupon.label,
        }))}
        aria-label="Select coupon"
    />
);
